export enum GridMode {
	VIEW = 'VIEW',
	EDIT = 'EDIT'
}

